import * as React from "react";
import type { SVGProps } from "react";
const SvgBow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.14 15.79a1 1 0 0 1-.7-.29 1 1 0 0 1 0-1.41l7.82-7.84a1.004 1.004 0 0 1 1.42 1.42L9.85 15.5a1 1 0 0 1-.71.29"
    />
    <path
      fill="currentColor"
      d="M19.21 9.32a2.58 2.58 0 0 1-1.83-.74 2.43 2.43 0 0 1-.68-1.35 2.47 2.47 0 0 1-1.37-.67 2.54 2.54 0 0 1-.76-1.83 2.7 2.7 0 0 1 .81-1.92 2.74 2.74 0 0 1 1.85-.79l3.75-.05a1 1 0 0 1 .71.3 1 1 0 0 1 .29.7v3.37a2.67 2.67 0 0 1-.8 2.15 2.72 2.72 0 0 1-1.97.83m-1.43-4.17a1 1 0 0 1 .94 1.33.74.74 0 0 0 .06.68.7.7 0 0 0 1-.05.68.68 0 0 0 .2-.57V3.97h-2.69a.72.72 0 0 0-.51.22.67.67 0 0 0-.21.49.6.6 0 0 0 .16.41.76.76 0 0 0 .72.06q.165-.021.33 0M10.09 14.85a1 1 0 0 1-.91-.59L5.4 5.77a1 1 0 0 1 .5-1.32 1 1 0 0 1 1.32.52l3.76 8.48a1 1 0 0 1-.5 1.32c-.123.053-.256.08-.39.08"
    />
    <path
      fill="currentColor"
      d="M14.34 10.61a1 1 0 0 1-.94-.64c-.54-1.58-1.22-3.56-5.78-3.7-2.57-.08-4-.63-4.55-1.73a2.06 2.06 0 0 1 .24-2.13 1 1 0 0 1 1.4-.2 1 1 0 0 1 .21 1.38.16.16 0 0 0 0 .09s.43.48 2.79.55c5.49.17 6.81 2.7 7.61 5.06a1 1 0 0 1-.62 1.27 1.3 1.3 0 0 1-.36.05M18.6 18.63q-.215 0-.41-.09l-8.5-3.77a1 1 0 1 1 .81-1.8l8.48 3.74a1.001 1.001 0 0 1 .152 1.75 1 1 0 0 1-.532.17"
    />
    <path
      fill="currentColor"
      d="M20.29 21.05a2 2 0 0 1-.83-.19c-1.1-.53-1.65-2-1.73-4.54-.14-4.55-2.12-5.22-3.75-5.76a1.005 1.005 0 1 1 .65-1.9c2.36.8 4.89 2.12 5.06 7.6.07 2.27.54 2.75.6 2.79 0 0 .06.04 0 0a1 1 0 0 1 1.38.26 1 1 0 0 1-.2 1.36 2.17 2.17 0 0 1-1.18.38M6.31 21.97a1 1 0 0 1-1-1v-2.3H2.98a1 1 0 0 1-.9-.7 1 1 0 0 1 .22-1l2.83-2.83a1 1 0 0 1 .71-.29h3.31a1 1 0 0 1 1 1v3.3a1 1 0 0 1-.3.71l-2.87 2.78a1 1 0 0 1-.67.33m-.89-5.3h.89a1 1 0 0 1 1 1v.89l.84-.84V15.8h-1.9z"
    />
  </svg>
);
export default SvgBow;
